






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Container extends Vue {
  @Prop({ default: 'medium' }) readonly size!:
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'
    | 'xxlarge';

  get classes() {
    return [`-size-${this.size}`];
  }
}
